import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar8 from "./navbar8";
import Footer4 from "./footer4";
import "./ContractorWagesPage.css";

const ContractorWagesPage = () => {
  const navigate = useNavigate();
  const [laborers, setLaborers] = useState([]);
  const dailyWage = 500;

  useEffect(() => {
    const savedLaborers = sessionStorage.getItem("laborers");
    if (savedLaborers) {
      setLaborers(JSON.parse(savedLaborers));
    }
  }, []);

  const markAsPaid = (id) => {
    setLaborers((prev) =>
      prev.map((lab) =>
        lab.id === id ? { ...lab, paid: true } : lab
      )
    );
    sessionStorage.setItem("laborers", JSON.stringify(laborers));
  };

  const markAsUnpaid = (id) => {
    setLaborers((prev) =>
      prev.map((lab) =>
        lab.id === id ? { ...lab, paid: false } : lab
      )
    );
    sessionStorage.setItem("laborers", JSON.stringify(laborers));
  };

  return (
    <>
      <Navbar8 />
      <div className="wages-container">
        <h1 className="wages-title">Manage Labor Wages</h1>
        
        {laborers.length === 0 ? (
          <p>No laborers found.</p>
        ) : (
          <table className="wages-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Days Present</th>
                <th>Total Wages</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {laborers.map((lab) => (
                <tr key={lab.id}>
                  <td>{lab.name}</td>
                  <td>{lab.attendance.length}</td>
                  <td>₹{lab.attendance.length * dailyWage}</td>
                  <td className={lab.paid ? "paid" : "unpaid"}>
                    {lab.paid ? "Paid" : "Unpaid"}
                  </td>
                  <td>
                    {!lab.paid ? (
                      <button className="mark-paid-btn" onClick={() => markAsPaid(lab.id)}>
                        Mark as Paid
                      </button>
                    ) : (
                      <button className="mark-unpaid-btn" onClick={() => markAsUnpaid(lab.id)}>
                        Mark as Unpaid
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <button className="back-btn" onClick={() => navigate("/attendance")}>
          Back to Attendance
        </button>
      </div>
      <Footer4 />
    </>
  );
};

export default ContractorWagesPage;
